export default __webpack_public_path__ + "static/media/MVRDV-slide-07.6b7ce08a.jpg";